export const degreesToRadians = (degrees: number) => degrees * (Math.PI / 180);